import PropTypes from 'prop-types';
import { screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

const noGradeProperties = {
  color: '#F1F1F1',
  threshold: 'insufficient',
};
const gradeProperties = [
  {
    threshold: 90,
    color: '#73C52D',
  },
  {
    threshold: 75,
    color: '#A2C52D',
  },
  {
    threshold: 50,
    color: '#F1C709',
  },
  {
    threshold: 0,
    color: '#F17108',
  },
];

export function getGradePoperties(percentagePositive) {
  return (
    gradeProperties.find(({ threshold, ...val }) => {
      if (percentagePositive && percentagePositive >= threshold) {
        return val;
      }

      return undefined;
    }) || noGradeProperties
  );
}

const ReportCard = ({ metaGrade }) => {
  const { t } = useTranslation();
  const properties = getGradePoperties(metaGrade);
  return (
    <div className="box clearfix">
      <div className="percentage">{metaGrade || '-'}%</div>
      <div className="text">
        <div>
          <h4>{t(`metaGrade.${properties.threshold}.name`)}</h4>
          <p>{t(`metaGrade.${properties.threshold}.recommendation`)}</p>
        </div>
      </div>
      <style jsx>{`
        .box {
          display: flex;
          border-color: ${properties.color};
          border-style: solid;
          border-width: thin;
          width: 45%;
          position: relative;
          height: 40px;
        }

        .percentage {
          display: flex;
          position: relative;
          justify-content: center;
          vertical-align: middle;
          align-items: center; /* align vertical */
          float: left;
          background-color: ${properties.color};
          height: 100%;
          width: 30%;
          color: white;
          font-weight: bold;
          text-align: center;
          margin: 0;
          margin-left: -1px;
          font-size: 1.2em;
        }

        .text {
          display: flex;
          position: relative;
          align-items: center; /* align vertical */
          float: left;
          height: 100%;
          flex: 1;
          padding-left: 7.5px;
          font-size: 0.7em;
          line-height: 0.9em;
        }

        h4 {
          font-size: 1.1em;
          margin: 0;
        }

        p {
          margin: 2px 0 0 0;
        }

        @media (min-width: ${screen.smMin}) {
          .box {
            height: 75px;
          }

          h4 {
            font-size: 1.3em;
          }

          .percentage {
            font-size: 2em;
          }

          .text {
            font-size: initial;
            padding-left: 15px;
          }

          p {
            margin: 5px 0 0 0;
          }
        }
      `}</style>
    </div>
  );
};
ReportCard.propTypes = {
  metaGrade: PropTypes.number,
};

export default ReportCard;
